var exports = {
  "zr": "GameOverlayHost.module__root___MUxhUF",
  "sQ": "GameOverlayHost.module__bottom___MUxhUF",
  "zY": "GameOverlayHost.module__speaking___MUxhUF",
  "eh": "GameOverlayHost.module__room___MUxhUF",
  "nM": "GameOverlayHost.module__row___MUxhUF",
  "my": "GameOverlayHost.module__avatar___MUxhUF",
  "su": "GameOverlayHost.module__avatarSpeaking___MUxhUF",
  "fs": "GameOverlayHost.module__micBadge___MUxhUF",
  "_2": "GameOverlayHost.module__micBadgeOff___MUxhUF",
  "Vo": "GameOverlayHost.module__micIcon___MUxhUF",
  "UU": "GameOverlayHost.module__name___MUxhUF",
  "ju": "GameOverlayHost.module__overflow___MUxhUF",
};

module.exports = exports;
